import { render, staticRenderFns } from "./optionsAdmin.vue?vue&type=template&id=5a6f3ee1&"
import script from "./optionsAdmin.vue?vue&type=script&lang=js&"
export * from "./optionsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6f3ee1')) {
      api.createRecord('5a6f3ee1', component.options)
    } else {
      api.reload('5a6f3ee1', component.options)
    }
    module.hot.accept("./optionsAdmin.vue?vue&type=template&id=5a6f3ee1&", function () {
      api.rerender('5a6f3ee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/optionsAdmin.vue"
export default component.exports